import './App.css';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { AuthProvider, useAuth } from './context/AuthContext';
import BottomNav from './components/BottomNav';
import SideNav from './components/SideNav';
import Splash from './components/Splash';
import { Toaster } from './components/ui/sonner';
import Home from './pages/Home';
import Auth from './pages/Auth';
import AiCoach from './pages/AiCoach';
import Assessments from './pages/Assessments';
import Education from './pages/Education';
import Consultation from './pages/Consultation';
import Profile from './pages/Profile';
import Admin from './pages/Admin';
import Onboarding from './pages/Onboarding';
import Founder from './pages/Founder';
import ArticleReader from './pages/ArticleReader';
import Journeys from './pages/Journeys';
import CoupleSpace from './pages/CoupleSpace';
import CoupleExercises from './pages/CoupleExercises';
import Affirmations from './pages/Affirmations';
import Ritual from './pages/Ritual';
const APP_ROUTES = ['/home', '/chat', '/learn', '/consult', '/you', '/assessments', '/admin', '/founder', '/article', '/journeys', '/couple', '/exercises', '/affirmations', '/ritual'];

const ProtectedRoute = ({ children, adminOnly }) => {
  const { user, loading } = useAuth();
  if (loading) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#0A0A0A' }}>
      <div className="gold-loader" />
    </div>
  );
  if (!user) return <Navigate to="/auth" replace />;
  if (adminOnly && user.role !== 'admin') return <Navigate to="/home" replace />;
  return children;
};

function AppContent() {
  const { pathname } = useLocation();
  const { user, loading } = useAuth();
  const [splash, setSplash] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => setSplash(false), 2200);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);

  const showBottomNav = user && APP_ROUTES.some(r => pathname.startsWith(r));

  if (loading && splash) return <Splash visible />;

  return (
    <div className={`app-shell${showBottomNav ? ' has-sidenav' : ''}`}>
      {/* Global gold-silk ambient backdrop on every page */}
      <div
        className="app-silk-global"
        aria-hidden="true"
        style={{ backgroundImage: "url('/assets/luxe-gold-silk-v2.png')" }}
      />
      <Splash visible={splash} />
      {showBottomNav && <SideNav />}
      <div className={`page-content${showBottomNav ? '' : ''}`} style={showBottomNav ? { paddingBottom: 'var(--bottom-h)' } : {}}>
        <Routes>
          {/* Public */}
          <Route path="/" element={user ? <Navigate to="/home" replace /> : <Navigate to="/auth" replace />} />
          <Route path="/auth" element={user ? <Navigate to="/home" replace /> : <Auth />} />
          <Route path="/onboarding" element={<ProtectedRoute><Onboarding /></ProtectedRoute>} />

          {/* App (authenticated, bottom nav) */}
          <Route path="/home"     element={<ProtectedRoute><Home /></ProtectedRoute>} />
          <Route path="/chat"     element={<ProtectedRoute><AiCoach /></ProtectedRoute>} />
          <Route path="/learn"    element={<ProtectedRoute><Education /></ProtectedRoute>} />
          <Route path="/assessments" element={<ProtectedRoute><Assessments /></ProtectedRoute>} />
          <Route path="/consult"  element={<ProtectedRoute><Consultation /></ProtectedRoute>} />
          <Route path="/you"      element={<ProtectedRoute><Profile /></ProtectedRoute>} />
          <Route path="/admin"    element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
          <Route path="/founder"  element={<ProtectedRoute><Founder /></ProtectedRoute>} />
          <Route path="/article/:id" element={<ProtectedRoute><ArticleReader /></ProtectedRoute>} />
          <Route path="/journeys" element={<ProtectedRoute><Journeys /></ProtectedRoute>} />
          <Route path="/ritual"   element={<ProtectedRoute><Ritual /></ProtectedRoute>} />
          <Route path="/couple"   element={<ProtectedRoute><CoupleSpace /></ProtectedRoute>} />
          <Route path="/exercises" element={<ProtectedRoute><CoupleExercises /></ProtectedRoute>} />
          <Route path="/affirmations" element={<ProtectedRoute><Affirmations /></ProtectedRoute>} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
      {showBottomNav && <BottomNav />}
      <Toaster position="top-center" theme="dark" />
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </AuthProvider>
  );
}
